import { combineReducers } from 'redux';
import { authenReducer } from './authen/reducer';
import { alertReducer } from './alert/reducer';
import { authenLineReducer } from './line/reducer';
import { infoReducer } from './info/reducer';

const rootReducer = combineReducers({
  authen: authenReducer,
  alert: alertReducer,
  line: authenLineReducer,
  info: infoReducer,
});

export default rootReducer;
